export const translations = {
  nl: {
    nav: {
      home: "Home",
      services: "Behandelingen",
      collection: "Collectie",
      how: "Hoe het werkt",
      contact: "Contact",
      book: "Boek nu",
    },
    hero: {
      overline: "Nagelstudio — Herzele, Oost-Vlaanderen",
      line1: "You'll be",
      line2: "hooked",
      line3: "On It!",
      sub: "Luxe press-on nagels op maat, BIAB en gellak — vakmanschap in het hart van Herzele, regio Zottegem.",
      cta1: "Boek een afspraak",
      cta2: "Ontdek de collectie",
      badge: "Handgemaakt • Op maat • Herbruikbaar",
      scroll: "Scroll",
    },
    marquee: ["Press-ons op maat", "BIAB", "Gellak", "Nail art", "Herzele — Zottegem", "Gift cards"],
    manifesto: {
      overline: "Het manifest",
      title: "Nagels als kunst,",
      titleItalic: "dragen als statement.",
      chapters: [
        {
          nr: "01",
          title: "De kunst van press-ons",
          text: "Elke set wordt met de hand ontworpen en afgewerkt in het atelier. Op jouw maat gemaakt, herbruikbaar en onmogelijk te onderscheiden van een salon manicure.",
          link: "Hoe het werkt",
        },
        {
          nr: "02",
          title: "Gel, BIAB & meer",
          text: "In het salon in Herzele krijg je een manicure op maat van jouw wensen — van natuurlijke BIAB-versteviging tot gellak in elke denkbare kleur.",
          link: "Bekijk behandelingen",
        },
        {
          nr: "03",
          title: "Seizoenscollecties",
          text: "Altijd beschikbaar, altijd on trend. Elke seizoensdrop is een gelimiteerde collectie — weg is echt weg.",
          link: "Shop de collectie",
        },
      ],
    },
    collectionTeaser: {
      overline: "De collectie",
      title: "Seizoens favorieten",
      sub: "Een selectie uit de nieuwste drops. Bestellen doe je eenvoudig via DM of WhatsApp.",
      cta: "Bekijk alles",
      from: "vanaf",
    },
    testimonials: {
      overline: "Ontdek wat zij al weten",
      title: "Geliefd door handen",
      titleItalic: "in de regio.",
      items: [
        { name: "Maureen", quote: "Mijn press-ons zitten na twee weken nog steeds perfect. Nog nooit zoveel complimenten gehad over mijn nagels." },
        { name: "Paulien", quote: "De pasvorm is ongelooflijk — je voelt gewoon niet dat je press-ons draagt. Echt op maat gemaakt." },
        { name: "Steffi", quote: "Van de opmeting tot de afwerking: alles voelt luxe. Dit is geen drogisterij-kwaliteit, dit is haute couture voor je handen." },
        { name: "Jessica", quote: "BIAB bij On It Nails betekent wekenlang perfecte nagels. Ik kom elke maand met plezier terug naar Herzele." },
      ],
    },
    giftcard: {
      overline: "Gift Card — Only for you",
      title: "Verwen jouw geliefden",
      titleItalic: "met luxe.",
      text: "Een cadeau waarvan je weet dat ze het verdienen. Of koop er eentje voor jezelf — ik zal niets zeggen.",
      cta: "Bestel een gift card",
    },
    footer: {
      tagline: "Nagelstudio & press-on atelier in Herzele. You'll be hooked On It!",
      newsletterTitle: "Blijf op de hoogte",
      newsletterText: "Enkel voor belangrijke zaken of te gekke kortingen. Beloofd.",
      newsletterPlaceholder: "jouw@email.be",
      newsletterCta: "Schrijf me in",
      newsletterDone: "Dankjewel! Je staat op de lijst.",
      explore: "Ontdek",
      contact: "Contact",
      hours: "Op afspraak",
      region: "Regio Herzele & Zottegem",
      rights: "Alle rechten voorbehouden.",
    },
    services: {
      overline: "Behandelingen & boeking",
      title: "Kies jouw",
      titleItalic: "behandeling.",
      sub: "Van verstevigende BIAB tot een volledige nail-art-set — elke behandeling is op maat van jouw nagels en jouw stijl.",
      duration: "min",
      from: "vanaf",
      list: [
        { id: "biab", name: "BIAB manicure", price: "€45", duration: 90, desc: "Builder In A Bottle — versteviging voor je natuurlijke nagels met een glanzende, natuurlijke finish. Ideaal om je eigen nagels te laten groeien." },
        { id: "gellak", name: "Gellak", price: "€35", duration: 60, desc: "Langhoudende glans in elke denkbare kleur, tot wel drie weken chip-vrij." },
        { id: "biab-nail-art", name: "BIAB + nail art", price: "€55", duration: 120, desc: "De stevigheid van BIAB gecombineerd met een handgeschilderd design naar keuze.", from: true },
        { id: "press-on-fitting", name: "Press-on fitting & plaatsing", price: "€25", duration: 30, desc: "We meten je nagels professioneel op en plaatsen je set ter plekke — perfect vanaf dag één." },
        { id: "manicure", name: "Verzorgende manicure", price: "€30", duration: 45, desc: "Nagelriemverzorging, vijlen, polijsten en een rijke verzorging voor gezonde nagels." },
        { id: "custom-press-ons", name: "Custom press-ons ontwerp", price: "€40", duration: 30, desc: "Jouw droomdesign, met de hand gemaakt op jouw maat. We bespreken je wensen in het salon.", from: true },
      ],
      bookingTitle: "Boek je afspraak",
      bookingSub: "Vul je gegevens in — je ontvangt snel een bevestiging van je tijdslot.",
      form: {
        name: "Naam",
        email: "E-mailadres",
        phone: "Telefoonnummer",
        service: "Behandeling",
        servicePlaceholder: "Kies een behandeling",
        date: "Gewenste datum",
        time: "Gewenst tijdstip",
        timePlaceholder: "Kies een tijdstip",
        notes: "Opmerkingen (optioneel)",
        notesPlaceholder: "Inspiratie, kleuren, vragen...",
        submit: "Verstuur boeking",
        sending: "Versturen...",
      },
      times: ["09:00", "10:30", "13:00", "14:30", "16:00", "18:00", "19:30"],
      successTitle: "Boeking ontvangen!",
      successText: "Dankjewel {name}! Je aanvraag voor {service} op {date} om {time} is goed aangekomen. Je hoort snel van me ter bevestiging.",
      successRef: "Referentie",
      successAgain: "Nog een boeking maken",
      error: "Er ging iets mis. Probeer het opnieuw of stuur een bericht via WhatsApp.",
      priceNote: "Prijzen zijn richtprijzen en worden bevestigd bij je afspraak.",
    },
    collection: {
      overline: "Press-on collectie",
      title: "Shop de",
      titleItalic: "collectie.",
      sub: "Meet je nagels eenmalig op voor je bestelt — zo zit elke set als gegoten. Bestellen via DM of WhatsApp.",
      filters: { all: "Alles", custom: "Custom", art: "Nail art", solid: "Effen kleur" },
      from: "vanaf",
      order: "Bestel via DM",
      orderWhatsapp: "WhatsApp",
      fitNote: "Twijfel je over je maat? Bekijk ",
      fitLink: "hoe het werkt",
      sizingKit: "Sizing kit — €5",
    },
    how: {
      overline: "Press-ons 101",
      title: "Perfect fit,",
      titleItalic: "perfect finish.",
      intro: "De juiste pasvorm is het geheim van comfort, duurzaamheid en een natuurlijke look. Zo werkt het — van opmeten tot dragen.",
      optionsTitle: "Twee manieren om te meten",
      option1Title: "Sizing kit",
      option1Text: "Koop een sizing kit in je gewenste vorm en lengte. Pas thuis nagel per nagel en noteer je maten — de zekerste methode.",
      option1Cta: "Bestel sizing kit (€5)",
      option2Title: "Zelf opmeten",
      option2Text: "Gebruik een zacht meetlint of plakband en volg de handleiding hieronder. Snel, gratis en verrassend nauwkeurig.",
      option2Cta: "Naar de collectie",
      stepsTitle: "Je nagels opmeten in 2 stappen",
      steps: [
        { nr: "Stap 1", title: "Meet de breedte", text: "Leg een zacht meetlint over het breedste deel van elke nagel en noteer de breedte in millimeters. Geen meetlint? Leg plakband over de nagel, markeer de randen en meet de afstand met een liniaal." },
        { nr: "Stap 2", title: "Match je maat", text: "Vergelijk je metingen met de maattabel (00–9) en geef je maten door bij je bestelling. Tussen twee maten? Kies de grotere — bijvijlen kan altijd." },
      ],
      sizeNote: "Standaard maten passen niet? Kies 'custom' bij je bestelling en noteer je maten per nagel.",
      tipsTitle: "Draag- & verzorgingstips",
      tips: [
        "Reinig en ontvet je nagels voor het plakken — zo blijven ze tot 2 weken zitten.",
        "Met lijmtabs draag je je set voor een avond; met nagellijm tot twee weken.",
        "Verwijderen? Week je handen in warm water met olie — nooit forceren.",
        "Bewaar je set in het doosje: press-ons van On It Nails zijn herbruikbaar.",
      ],
      faqTitle: "Veelgestelde vragen",
      faq: [
        { q: "Hoe lang blijven press-ons zitten?", a: "Met nagellijm tot twee weken, met lijmtabs één tot drie dagen. De juiste maat en goede voorbereiding maken het verschil." },
        { q: "Zijn de press-ons herbruikbaar?", a: "Ja! Verwijder ze voorzichtig, maak de binnenkant proper en bewaar ze in het doosje. Zo gaat een set vele dragen mee." },
        { q: "Wat als mijn nagels niet in de maattabel passen?", a: "Kies dan voor 'custom' bij je bestelling en geef je maten per nagel door. Elke nagel wordt dan exact op maat gemaakt." },
        { q: "Kan ik ook in het salon langskomen?", a: "Zeker — boek een press-on fitting in Herzele. Ik meet je nagels professioneel op en plaats je set meteen perfect." },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Zullen we",
      titleItalic: "kennismaken?",
      sub: "Vraag over een design, je maat of een afspraak? Stuur een bericht — ik antwoord meestal binnen de 24u.",
      addressTitle: "Het salon",
      address: "Herzele, Oost-Vlaanderen",
      addressNote: "Het exacte adres ontvang je bij je boeking.",
      hoursTitle: "Openingsuren",
      hours: [
        { day: "Maandag – Vrijdag", time: "Op afspraak" },
        { day: "Zaterdag", time: "Op afspraak" },
        { day: "Zondag", time: "Gesloten" },
      ],
      regionTitle: "Regio",
      regionText: "Herzele, Zottegem & omstreken",
      form: {
        name: "Naam",
        email: "E-mailadres",
        message: "Bericht",
        messagePlaceholder: "Waarmee kan ik je helpen?",
        submit: "Verstuur bericht",
        sending: "Versturen...",
        successTitle: "Bericht verzonden!",
        successText: "Dankjewel {name}! Ik neem zo snel mogelijk contact met je op.",
        again: "Nog een bericht sturen",
        error: "Versturen mislukt. Probeer opnieuw of stuur rechtstreeks een WhatsApp.",
      },
    },
    admin: {
      title: "Beheer",
      loginTitle: "Log in op je dashboard",
      email: "E-mailadres",
      password: "Wachtwoord",
      loginCta: "Inloggen",
      loggingIn: "Even geduld...",
      loginError: "Onjuiste inloggegevens. Probeer opnieuw.",
      logout: "Uitloggen",
      tabBookings: "Boekingen",
      tabMessages: "Berichten",
      tabHours: "Openingsuren",
      hoursIntro: "Stel per weekdag in welke tijdslots klanten kunnen kiezen. Laat een dag leeg om het salon die dag te sluiten.",
      closedLabel: "Gesloten",
      saveHours: "Opslaan",
      hoursSaved: "Openingsuren opgeslagen!",
      days: { monday: "Maandag", tuesday: "Dinsdag", wednesday: "Woensdag", thursday: "Donderdag", friday: "Vrijdag", saturday: "Zaterdag", sunday: "Zondag" },
      tabClients: "Klanten",
      clientSearch: "Zoek op naam, e-mail of telefoon...",
      noClients: "Nog geen klanten.",
      noResults: "Geen klanten gevonden voor je zoekopdracht.",
      newsletterBadge: "Nieuwsbrief",
      appointments: "afspraken",
      messagesLabel: "berichten",
      exportClients: "Exporteer (CSV)",
      tabSite: "Website",
      siteImagesTitle: "Foto's op de site",
      siteColorsTitle: "Kleuren van de site",
      uploadCta: "Upload",
      uploading: "Uploaden...",
      siteSaved: "Site-instellingen opgeslagen!",
      resetImage: "Herstel origineel",
      presetsLabel: "Paletten",
      accentLabel: "Accentkleur",
      accentDarkLabel: "Accent donker",
      blushLabel: "Zachte tint",
      imageLabels: { heroMain: "Hero — grote foto", heroSecondary: "Hero — kleine foto", booking: "Boekingssectie", howHero: "Hoe het werkt", giftcard: "Gift card" },
      depositPaid: "Voorschot betaald",
      depositOpen: "Voorschot open",
      noBookings: "Nog geen boekingen.",
      noMessages: "Nog geen berichten.",
      confirm: "Bevestig",
      cancelBooking: "Annuleer",
      statusPending: "In afwachting",
      statusConfirmed: "Bevestigd",
      statusCancelled: "Geannuleerd",
      calendarTitle: "Google Agenda",
      calendarText: "Koppel je Google Agenda en nieuwe boekingen verschijnen automatisch als afspraak in je agenda.",
      calendarConnect: "Koppel Google Agenda",
      calendarConnected: "Gekoppeld als",
      calendarNotConnected: "Nog niet gekoppeld",
      agendaConnectedToast: "Google Agenda gekoppeld!",
    },
    slots: {
      pickDate: "Kies eerst een datum om de vrije tijdslots te zien.",
      closedSunday: "Het salon is gesloten op deze dag — kies een andere dag.",
      conflict: "Dit tijdslot is zonet geboekt. Kies een ander moment.",
      loading: "Tijdslots laden...",
    },
    payment: {
      depositNote: "Je boeking wordt definitief na betaling van het voorschot (€20) via Bancontact of kaart. Het voorschot wordt verrekend met je behandeling.",
      submitPay: "Boek & betaal voorschot",
      processingTitle: "Betaling controleren...",
      processingText: "Even geduld — we bevestigen je betaling.",
      successTitle: "Betaling gelukt!",
      successText: "Je voorschot is betaald en je boeking is definitief. Tot snel in het salon!",
      pendingTitle: "Betaling in verwerking",
      pendingText: "Je bank verwerkt de betaling nog. Je boeking staat al vast — je ontvangt een bevestiging zodra de betaling rond is.",
      failTitle: "Betaling niet gelukt",
      failText: "Er ging iets mis bij de betaling. Je boeking staat wel genoteerd — probeer opnieuw of betaal in het salon.",
      cancelToast: "Betaling geannuleerd — je boeking staat genoteerd, het voorschot kan je later of in het salon betalen.",
      backHome: "Terug naar home",
      refLabel: "Referentie",
    },
    seo: {
      home: { title: "On It Nails — Press-on nagels, BIAB & Gellak in Herzele", desc: "Nagelstudio in Herzele voor luxe press-on nagels op maat, BIAB en gellak manicures. Boek je afspraak regio Herzele & Zottegem." },
      services: { title: "Behandelingen & boeken — BIAB, gellak & press-ons | On It Nails Herzele", desc: "Boek online je BIAB manicure, gellak of press-on fitting in Herzele. Manicure op maat, regio Herzele & Zottegem." },
      collection: { title: "Press-on collectie — handgemaakte nagels op maat | On It Nails", desc: "Shop luxe handgemaakte press-on nagels op maat. Custom designs, nail art en effen kleuren. Verzending in heel België." },
      how: { title: "Hoe werken press-on nagels? Opmeten & dragen | On It Nails", desc: "Leer je nagels opmeten met sizing kit of meetlint voor de perfecte pasvorm. Handleiding, maattabel en tips." },
      contact: { title: "Contact — Nagelstudio Herzele | On It Nails", desc: "Contacteer On It Nails in Herzele voor vragen over press-ons, BIAB of je boeking. Regio Herzele & Zottegem." },
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      collection: "Collection",
      how: "How it works",
      contact: "Contact",
      book: "Book now",
    },
    hero: {
      overline: "Nail studio — Herzele, East Flanders",
      line1: "You'll be",
      line2: "hooked",
      line3: "On It!",
      sub: "Luxury custom press-on nails, BIAB and gel polish — craftsmanship in the heart of Herzele, near Zottegem.",
      cta1: "Book an appointment",
      cta2: "Explore the collection",
      badge: "Handmade • Made to measure • Reusable",
      scroll: "Scroll",
    },
    marquee: ["Custom press-ons", "BIAB", "Gel polish", "Nail art", "Herzele — Zottegem", "Gift cards"],
    manifesto: {
      overline: "The manifesto",
      title: "Nails as art,",
      titleItalic: "worn as a statement.",
      chapters: [
        {
          nr: "01",
          title: "The art of press-ons",
          text: "Every set is designed and finished by hand in the atelier. Made to your measurements, reusable and impossible to tell apart from a salon manicure.",
          link: "How it works",
        },
        {
          nr: "02",
          title: "Gel, BIAB & more",
          text: "In the Herzele studio you get a manicure tailored to your wishes — from natural BIAB strengthening to gel polish in every shade imaginable.",
          link: "View services",
        },
        {
          nr: "03",
          title: "Seasonal collections",
          text: "Always available, always on trend. Every seasonal drop is a limited collection — gone really means gone.",
          link: "Shop the collection",
        },
      ],
    },
    collectionTeaser: {
      overline: "The collection",
      title: "Seasonal favourites",
      sub: "A selection from the latest drops. Ordering is easy via DM or WhatsApp.",
      cta: "View everything",
      from: "from",
    },
    testimonials: {
      overline: "Discover what they already know",
      title: "Loved by hands",
      titleItalic: "across the region.",
      items: [
        { name: "Maureen", quote: "After two weeks my press-ons are still perfect. Never had so many compliments on my nails." },
        { name: "Paulien", quote: "The fit is unbelievable — you simply don't feel you're wearing press-ons. Truly made to measure." },
        { name: "Steffi", quote: "From sizing to finish: everything feels luxurious. This isn't drugstore quality, it's haute couture for your hands." },
        { name: "Jessica", quote: "BIAB at On It Nails means weeks of flawless nails. I happily return to Herzele every month." },
      ],
    },
    giftcard: {
      overline: "Gift Card — Only for you",
      title: "Treat your loved ones",
      titleItalic: "to luxury.",
      text: "A gift you know they deserve. Or buy one for yourself — I won't tell.",
      cta: "Order a gift card",
    },
    footer: {
      tagline: "Nail studio & press-on atelier in Herzele. You'll be hooked On It!",
      newsletterTitle: "Stay in the loop",
      newsletterText: "Only for the important things or crazy discounts. Promised.",
      newsletterPlaceholder: "you@email.com",
      newsletterCta: "Sign me up",
      newsletterDone: "Thank you! You're on the list.",
      explore: "Explore",
      contact: "Contact",
      hours: "By appointment",
      region: "Herzele & Zottegem area",
      rights: "All rights reserved.",
    },
    services: {
      overline: "Services & booking",
      title: "Choose your",
      titleItalic: "treatment.",
      sub: "From strengthening BIAB to a full nail-art set — every treatment is tailored to your nails and your style.",
      duration: "min",
      from: "from",
      list: [
        { id: "biab", name: "BIAB manicure", price: "€45", duration: 90, desc: "Builder In A Bottle — strengthening for your natural nails with a glossy, natural finish. Ideal for growing out your own nails." },
        { id: "gellak", name: "Gel polish", price: "€35", duration: 60, desc: "Long-lasting shine in any shade imaginable, chip-free for up to three weeks." },
        { id: "biab-nail-art", name: "BIAB + nail art", price: "€55", duration: 120, desc: "The strength of BIAB combined with a hand-painted design of your choice.", from: true },
        { id: "press-on-fitting", name: "Press-on fitting & application", price: "€25", duration: 30, desc: "We measure your nails professionally and apply your set on the spot — perfect from day one." },
        { id: "manicure", name: "Care manicure", price: "€30", duration: 45, desc: "Cuticle care, filing, buffing and rich nourishment for healthy nails." },
        { id: "custom-press-ons", name: "Custom press-on design", price: "€40", duration: 30, desc: "Your dream design, handmade to your measurements. We discuss your wishes in the studio.", from: true },
      ],
      bookingTitle: "Book your appointment",
      bookingSub: "Fill in your details — you'll receive a confirmation of your time slot shortly.",
      form: {
        name: "Name",
        email: "Email address",
        phone: "Phone number",
        service: "Treatment",
        servicePlaceholder: "Choose a treatment",
        date: "Preferred date",
        time: "Preferred time",
        timePlaceholder: "Choose a time",
        notes: "Notes (optional)",
        notesPlaceholder: "Inspiration, colours, questions...",
        submit: "Send booking",
        sending: "Sending...",
      },
      times: ["09:00", "10:30", "13:00", "14:30", "16:00", "18:00", "19:30"],
      successTitle: "Booking received!",
      successText: "Thank you {name}! Your request for {service} on {date} at {time} has arrived safely. You'll hear from me soon to confirm.",
      successRef: "Reference",
      successAgain: "Make another booking",
      error: "Something went wrong. Please try again or send a message via WhatsApp.",
      priceNote: "Prices are indicative and confirmed at your appointment.",
    },
    collection: {
      overline: "Press-on collection",
      title: "Shop the",
      titleItalic: "collection.",
      sub: "Measure your nails once before ordering — so every set fits like a glove. Order via DM or WhatsApp.",
      filters: { all: "All", custom: "Custom", art: "Nail art", solid: "Solid colour" },
      from: "from",
      order: "Order via DM",
      orderWhatsapp: "WhatsApp",
      fitNote: "Unsure about your size? See ",
      fitLink: "how it works",
      sizingKit: "Sizing kit — €5",
    },
    how: {
      overline: "Press-ons 101",
      title: "Perfect fit,",
      titleItalic: "perfect finish.",
      intro: "The right fit is the secret to comfort, durability and a natural look. Here's how it works — from measuring to wearing.",
      optionsTitle: "Two ways to measure",
      option1Title: "Sizing kit",
      option1Text: "Buy a sizing kit in your desired shape and length. Try each nail at home and note your sizes — the most reliable method.",
      option1Cta: "Order sizing kit (€5)",
      option2Title: "Measure yourself",
      option2Text: "Use a soft measuring tape or tape and follow the guide below. Quick, free and surprisingly accurate.",
      option2Cta: "To the collection",
      stepsTitle: "Measure your nails in 2 steps",
      steps: [
        { nr: "Step 1", title: "Measure the width", text: "Place a soft measuring tape across the widest part of each nail and note the width in millimetres. No tape? Place adhesive tape over the nail, mark the edges and measure the distance with a ruler." },
        { nr: "Step 2", title: "Match your size", text: "Compare your measurements with the size chart (00–9) and share your sizes with your order. Between two sizes? Go bigger — you can always file a little." },
      ],
      sizeNote: "Standard sizes don't fit? Choose 'custom' with your order and note your sizes per nail.",
      tipsTitle: "Wear & care tips",
      tips: [
        "Clean and degrease your nails before applying — they'll last up to 2 weeks.",
        "Use adhesive tabs for one evening; nail glue keeps them on for up to two weeks.",
        "Removing? Soak your hands in warm water with oil — never force them off.",
        "Store your set in the box: On It Nails press-ons are reusable.",
      ],
      faqTitle: "Frequently asked questions",
      faq: [
        { q: "How long do press-ons last?", a: "Up to two weeks with nail glue, one to three days with adhesive tabs. The right size and good preparation make all the difference." },
        { q: "Are the press-ons reusable?", a: "Yes! Remove them carefully, clean the inside and store them in the box. A set lasts through many wears." },
        { q: "What if my nails don't match the size chart?", a: "Choose 'custom' with your order and share your sizes per nail. Every nail is then made exactly to measure." },
        { q: "Can I visit the studio?", a: "Absolutely — book a press-on fitting in Herzele. I'll measure your nails professionally and apply your set perfectly right away." },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Shall we",
      titleItalic: "meet?",
      sub: "Question about a design, your size or an appointment? Send a message — I usually reply within 24 hours.",
      addressTitle: "The studio",
      address: "Herzele, East Flanders",
      addressNote: "You'll receive the exact address with your booking.",
      hoursTitle: "Opening hours",
      hours: [
        { day: "Monday – Friday", time: "By appointment" },
        { day: "Saturday", time: "By appointment" },
        { day: "Sunday", time: "Closed" },
      ],
      regionTitle: "Area",
      regionText: "Herzele, Zottegem & surroundings",
      form: {
        name: "Name",
        email: "Email address",
        message: "Message",
        messagePlaceholder: "How can I help you?",
        submit: "Send message",
        sending: "Sending...",
        successTitle: "Message sent!",
        successText: "Thank you {name}! I'll get back to you as soon as possible.",
        again: "Send another message",
        error: "Sending failed. Please try again or send a WhatsApp directly.",
      },
    },
    admin: {
      title: "Dashboard",
      loginTitle: "Log in to your dashboard",
      email: "Email address",
      password: "Password",
      loginCta: "Log in",
      loggingIn: "One moment...",
      loginError: "Incorrect credentials. Please try again.",
      logout: "Log out",
      tabBookings: "Bookings",
      tabMessages: "Messages",
      tabHours: "Opening hours",
      hoursIntro: "Set which time slots clients can choose for each weekday. Leave a day empty to close the studio that day.",
      closedLabel: "Closed",
      saveHours: "Save",
      hoursSaved: "Opening hours saved!",
      days: { monday: "Monday", tuesday: "Tuesday", wednesday: "Wednesday", thursday: "Thursday", friday: "Friday", saturday: "Saturday", sunday: "Sunday" },
      tabClients: "Clients",
      clientSearch: "Search by name, email or phone...",
      noClients: "No clients yet.",
      noResults: "No clients match your search.",
      newsletterBadge: "Newsletter",
      appointments: "appointments",
      messagesLabel: "messages",
      exportClients: "Export (CSV)",
      tabSite: "Website",
      siteImagesTitle: "Photos on the site",
      siteColorsTitle: "Site colours",
      uploadCta: "Upload",
      uploading: "Uploading...",
      siteSaved: "Site settings saved!",
      resetImage: "Reset to original",
      presetsLabel: "Palettes",
      accentLabel: "Accent colour",
      accentDarkLabel: "Accent dark",
      blushLabel: "Soft tint",
      imageLabels: { heroMain: "Hero — large photo", heroSecondary: "Hero — small photo", booking: "Booking section", howHero: "How it works", giftcard: "Gift card" },
      depositPaid: "Deposit paid",
      depositOpen: "Deposit open",
      noBookings: "No bookings yet.",
      noMessages: "No messages yet.",
      confirm: "Confirm",
      cancelBooking: "Cancel",
      statusPending: "Pending",
      statusConfirmed: "Confirmed",
      statusCancelled: "Cancelled",
      calendarTitle: "Google Calendar",
      calendarText: "Connect your Google Calendar and new bookings will automatically appear as events in your agenda.",
      calendarConnect: "Connect Google Calendar",
      calendarConnected: "Connected as",
      calendarNotConnected: "Not connected yet",
      agendaConnectedToast: "Google Calendar connected!",
    },
    slots: {
      pickDate: "Choose a date first to see the available time slots.",
      closedSunday: "The studio is closed on this day — please pick another day.",
      conflict: "This time slot was just booked. Please choose another moment.",
      loading: "Loading time slots...",
    },
    payment: {
      depositNote: "Your booking becomes final after paying the deposit (€20) via Bancontact or card. The deposit is deducted from your treatment.",
      submitPay: "Book & pay deposit",
      processingTitle: "Checking your payment...",
      processingText: "One moment — we're confirming your payment.",
      successTitle: "Payment successful!",
      successText: "Your deposit is paid and your booking is final. See you soon at the studio!",
      pendingTitle: "Payment processing",
      pendingText: "Your bank is still processing the payment. Your booking is secured — you'll receive a confirmation once it completes.",
      failTitle: "Payment failed",
      failText: "Something went wrong during payment. Your booking is still noted — try again or pay at the studio.",
      cancelToast: "Payment cancelled — your booking is noted, you can pay the deposit later or at the studio.",
      backHome: "Back to home",
      refLabel: "Reference",
    },
    seo: {
      home: { title: "On It Nails — Press-on nails, BIAB & Gel polish in Herzele", desc: "Nail studio in Herzele for luxury custom press-on nails, BIAB and gel manicures. Book your appointment in the Herzele & Zottegem area." },
      services: { title: "Services & booking — BIAB, gel polish & press-ons | On It Nails Herzele", desc: "Book your BIAB manicure, gel polish or press-on fitting online in Herzele. Tailored manicures in the Herzele & Zottegem area." },
      collection: { title: "Press-on collection — handmade nails made to measure | On It Nails", desc: "Shop luxury handmade press-on nails made to measure. Custom designs, nail art and solid colours. Shipping across Belgium." },
      how: { title: "How do press-on nails work? Measuring & wearing | On It Nails", desc: "Learn to measure your nails with a sizing kit or tape for the perfect fit. Guide, size chart and tips." },
      contact: { title: "Contact — Nail studio Herzele | On It Nails", desc: "Contact On It Nails in Herzele for questions about press-ons, BIAB or your booking. Herzele & Zottegem area." },
    },
  },
};
